import React from 'react';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import PolarisIcon from '@/components/_common/PolarisIcon';

interface NoDataMessageProps {
  message?: string;
  className?: string;
}

const NoDataMessage = ({ message, className }: NoDataMessageProps) => {
  return (
    <NoDataMessageWrapper align="center" variant="h5" className={className}>
      <PolarisIcon icon="info" />
      {message || 'No data available'}
    </NoDataMessageWrapper>
  );
};

export default NoDataMessage;

const NoDataMessageWrapper = styled(Typography)`
  width: 100%;
  min-height: 100px;
  padding-bottom: ${({ theme }) => theme.spacing(3)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  & > svg {
    font-size: 1.66rem;
    margin-right: ${({ theme }) => theme.spacing(1.5)};
    color: ${({ theme }) => theme.palette.default.main};
  }
`;
